export default __webpack_public_path__ + "static/media/970.04317b31.gif";